<template>
  <div>
    <ts-page-title
      :title="$t('levelSkillSubject.pageTitle')"
      :breadcrumb="[
        { text: $t('home'), href: '/' },
        {
          text: $t('levelSkillSubject.pageTitle'),
          active: true,
        },
      ]"
    />
    <ts-panel>
      <ts-panel-wrapper class="tw-flex tw-items-center tw-justify-between">
        <a-button
          type="primary"
          @click="$router.push({ name: 'level-skill-subject-create' })"
        >
          {{ $t("addNew") }}
        </a-button>
        <div class="tw-justify-end">
          <a-input
            v-model="search"
            v-tooltip="$t('levelSkillSubject.search')"
            :placeholder="$t('levelSkillSubject.search')"
            style="width: 250px"
            class="inline-block"
          />
        </div>
      </ts-panel-wrapper>
      <div class="tw-overflow-auto">
        <ts-table
          :columns="columns"
          :records="resources"
          :loading="loading"
          :expandable="true"
        >
          <template v-slot="{ record }">
            <td class="tw-whitespace-nowrap">{{ record.level_skill_name }}</td>
            <td class="tw-whitespace-nowrap">
              {{ record.skill_name_en }}
              <span
                v-if="record.is_accessor"
                class="badge bg-primary mr-2 tw-capitalize"
              >
                Accessor</span
              >
            </td>
            <td class="tw-whitespace-nowrap">
              {{ record.skill_name_kh }}
              <span
                v-if="record.is_accessor"
                class="badge bg-primary mr-2 tw-capitalize"
              >
                Accessor</span
              >
            </td>
            <td class="text-center tw-whitespace-nowrap">
              {{ record.skill_level_order }}
            </td>
            <td class="text-center tw-space-x-3 tw-whitespace-nowrap">
              <a
                href="#"
                v-tooltip="$t('edit')"
                class="text-primary mr-2"
                @click.prevent="edit(record)"
              >
                <i class="fas fa-edit"></i>
              </a>
              <a-popconfirm
                placement="leftTop"
                :title="$t('are_you_sure_to_delete')"
                :ok-text="$t('yes')"
                :cancel-text="$t('no')"
                @confirm="deleteRecord(record)"
              >
                <a href="#" :disabled="record._deleting">
                  <i
                    class="fas fa-circle-notch spin"
                    v-if="record._deleting"
                  ></i>
                  <i class="fa fa-trash text-red" v-else></i>
                </a>
              </a-popconfirm>
            </td>
          </template>

          <div slot="expand" slot-scope="prop">
            <table class="tw-w-11/12 tw-mx-auto detail">
              <thead>
                <tr class="tw-uppercase tw-bg-gray-200 tw-h-8 tw-text-white">
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("levelSkillSubject.subjectCode") }}
                  </th>
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("levelSkillSubject.nameKH") }}
                  </th>
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("levelSkillSubject.nameEN") }}
                  </th>
                  <th class="tw-pl-2 tw-whitespace-nowrap">
                    {{ $t("levelSkillSubject.subjectType") }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  class="tw-border-b-2"
                  v-for="(detail, index) in prop.record.skill_subjects"
                  :key="index"
                >
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.subject_code }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.subject_name_en }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.subject_name_kh }}
                  </td>
                  <td class="tw-p-2 tw-whitespace-nowrap">
                    {{ detail.subject_type_id == 1 ? "Basic" : "Core" }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </ts-table>
      </div>
      <div class="d-flex justify-content-end tw-p-4">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-panel>

    <a-modal
      v-if="showForm"
      v-model="showForm"
      :title="$t('levelSkillSubject.pageTitle')"
      centered
      :maskClosable="false"
      @cancel="clearEdit"
      :zIndex="1020"
      :footer="null"
      :width="700"
    >
      <from-action @cancel="clearEdit" />
    </a-modal>
  </div>
</template>

<script>
import { debounce } from "lodash";
import { mapState } from "vuex";
export default {
  name: "levelSkillSubjectIndex",
  components: {},
  data() {
    return {
      loading: false,
      showForm: false,
    };
  },
  computed: {
    ...mapState("academic/levelSkillSubject", ["resources", "pagination"]),
    search: {
      get() {
        return this.$store.state.academic.levelSkillSubject.search;
      },
      set(newValue) {
        this.$store.commit("academic/levelSkillSubject/SET_SEARCH", newValue);
        this.$store.commit("academic/levelSkillSubject/RESET_CURRENT_PAGE");
      },
    },
    columns() {
      return [
        {
          name: this.$t("levelSkillSubject.levelSkillName"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("levelSkillSubject.skillEn"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("levelSkillSubject.skillKh"),
          style: "white-space: nowrap;",
        },
        {
          name: this.$t("levelSkillSubject.skillLevelOrder"),
          style: "text-align:center;white-space: nowrap;",
        },
        {
          name: this.$t("actions"),
          style: "text-align:center; width: 1px;white-space: nowrap;",
        },
      ];
    },
  },
  methods: {
    fetchData(attributes) {
      this.loading = true;
      this.$store
        .dispatch("academic/levelSkillSubject/fetch", { ...attributes })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$notify({ type: "error", text: error.message });
        });
    },
    deleteRecord(record) {
      record._deleting = true;
      this.$store
        .dispatch("academic/levelSkillSubject/destroy", record.level_skill_id)
        .then((response) => {
          this.$notify({ type: "success", text: response.message });
          this.fetchData();
        })
        .catch((error) => {
          this.$notify({ type: "error", text: error.message });
        })
        .finally(() => {
          record._deleting = false;
        });
    },
    edit(record) {
      this.$store.commit("academic/levelSkillSubject/SET_EDIT_DATA", record);
      this.$router.push({ name: "level-skill-subject-edit" });
    },
    clearEdit() {
      this.showForm = false;
      this.fetchData();
    },
  },
  watch: {
    search: debounce(function () {
      this.fetchData();
    }, 500),
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit("academic/levelSkillSubject/RESET_STATE");
    next();
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
};
</script>
